<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Booth History</h5>
            </div>
            <hr />
            <div class="row">
                <div class="col-12 text-start">
                    <ul class="nav nav-tabs custom-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" data-bs-toggle="tab" href="#boothHistory">Booth History</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane fade show active" id="boothHistory">
                            <div class="p-3">
                                <div class="row g-3 align-items-end">

                                    <div class="col-md-6 col-lg-3">
                                        <label for="booth" class="form-label">Booth</label>
                                        <div class="input-group">
                                            <input type="text" id="booth" class="form-control">
                                            <button class="btn btn-dark" type="button">
                                                <i class="bi bi-search"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-lg-3">
                                        <label for="boothType" class="form-label">Booth Type</label>
                                        <input type="text" id="boothType" class="form-control">
                                    </div>

                                    <div class="col-md-6 col-lg-3">
                                        <label for="boothDesc" class="form-label">Booth Desc</label>
                                        <input type="text" id="boothDesc" class="form-control">
                                    </div>
                                </div>
                                <div class="row g-3 align-items-end my-2">
                                    <div class="col-md-4 col-lg-2">
                                        <label for="length" class="form-label">Length</label>
                                        <input type="text" id="length" class="form-control">
                                    </div>

                                    <div class="col-md-4 col-lg-2">
                                        <label for="width" class="form-label">Width</label>
                                        <input type="text" id="width" class="form-control">
                                    </div>

                                    <div class="col-md-6 col-lg-4">
                                        <label for="notes" class="form-label">Notes</label>
                                        <div class="input-group">
                                            <input type="text" id="notes" class="form-control">
                                            <button class="btn btn-dark" type="button">
                                                <i class="bi bi-three-dots"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <h6 class="fw-bold mb-3">Booth Pricing</h6>
                                <div class="row">
                                    <div class="col-auto">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="Daily" id="rdDaily">
                                            <label class="form-check-label" for="rdDaily">
                                                Daily
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="Weekly" id="rdWeekly">
                                            <label class="form-check-label" for="rdWeekly">
                                                Weekly
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="Monthly" id="rdMonthly">
                                            <label class="form-check-label" for="rdMonthly">
                                                Monthly
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 text-start mt-2">
                                        <ejs-grid [allowResizing]="true" [height]="200">
                                            <e-columns>
                                                <e-column field="mktDay" headerText="Mkt Day" width="120"></e-column>
                                                <e-column field="jan" headerText="Jan" width="80"></e-column>
                                                <e-column field="feb" headerText="Feb" width="80"></e-column>
                                                <e-column field="mar" headerText="Mar" width="80"></e-column>
                                                <e-column field="apr" headerText="Apr" width="80"></e-column>
                                                <e-column field="may" headerText="May" width="80"></e-column>
                                                <e-column field="jun" headerText="Jun" width="80"></e-column>
                                                <e-column field="jul" headerText="Jul" width="80"></e-column>
                                                <e-column field="aug" headerText="Aug" width="80"></e-column>
                                                <e-column field="sep" headerText="Sep" width="80"></e-column>
                                                <e-column field="oct" headerText="Oct" width="80"></e-column>
                                                <e-column field="nov" headerText="Nov" width="80"></e-column>
                                                <e-column field="dec" headerText="Dec" width="80"></e-column>
                                            </e-columns>
                                        </ejs-grid>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-lg-9 text-start mt-2">
                                        <div class="calendar mb-2">
                                            <div class="table-responsive">
                                                <table
                                                    class="table table-striped text-center mb-0 table-layout-inherit">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="5">
                                                                <div class="month-selector">
                                                                    <div class="custom-dropdown">
                                                                        <span class="arrow up">&#9650;</span>
                                                                        <select class="month-dropdown">
                                                                            <option></option>
                                                                        </select>
                                                                        <span class="arrow down">&#9660;</span>
                                                                    </div>
                                                                </div>
                                                            </th>
                                                            <th colspan="2">
                                                                <div class="year-selector">
                                                                    <div class="custom-dropdown">
                                                                        <span class="arrow up">&#9650;</span>
                                                                        <select class="year-dropdown">
                                                                            <option>2025</option>
                                                                        </select>
                                                                        <span class="arrow down">&#9660;</span>
                                                                    </div>
                                                                </div>
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th class="fixed-width-th">Monday</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <ng-container>
                                                                <td class="fixed-width-td">
                                                                    <div class="day-number">01</div>
                                                                    <div>
                                                                        <img src="./../assets/images/letter-xB.svg"
                                                                            class="imgCalendar">
                                                                    </div>
                                                                    <div>
                                                                        <img src="./../assets/images/letter-a.svg"
                                                                            class="imgCalendar">
                                                                    </div>
                                                                    <div>
                                                                        <img src="./../assets/images/letter-b.svg"
                                                                            class="imgCalendar">
                                                                    </div>
                                                                    <div>
                                                                        <img src="./../assets/images/letter-c.svg"
                                                                            class="imgCalendar">
                                                                    </div>
                                                                    <div>
                                                                        <img src="./../assets/images/letter-o.svg"
                                                                            class="imgCalendar">
                                                                    </div>
                                                                    <div>
                                                                        <img src="./../assets/images/letter-v.svg"
                                                                            class="imgCalendar">
                                                                    </div>
                                                                    <div>
                                                                        <img src="./../assets/images/letter-r.svg"
                                                                            class="imgCalendar">
                                                                    </div>
                                                                </td>
                                                            </ng-container>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-3 text-start mt-2">
                                        <div class="shadow">
                                            <div class="container">
                                                <div class="legend py-3">
                                                    <div class="legend-item">
                                                        <span class="circle booked">B</span> Booked
                                                    </div>
                                                    <div class="legend-item">
                                                        <span class="circle reserved">R</span> Reserved
                                                    </div>
                                                    <div class="legend-item">
                                                        <span class="circle old-bookings">✖</span> Old Bookings
                                                    </div>
                                                    <div class="legend-item">
                                                        <span class="circle available">A</span> Available
                                                    </div>
                                                    <div class="legend-item">
                                                        <span class="circle close-out">C</span> Close Out
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 text-end my-2">
                                        <button class="btn btnAS me-1">Close Out</button>
                                        <button class="btn btn-orange">Release</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>